module.exports = __webpack_public_path__ + "static/024_001-32a5b146e40c114e69bdd3c79fd30d49.jpg";